import React, { useCallback } from "react";
import Button from "react-bootstrap/Button";
import { ArrowUp } from "react-bootstrap-icons";
import { useScrollTopAvailability } from "@/hooks/useScrollTopAvailability";

interface ScrollTopButtonProps {
  activationScrollY?: number;
  scrollContainerId?: string;
  rightOffsetPx?: number;
  bottomOffsetPx?: number;
}

const ScrollTopButton: React.FC<ScrollTopButtonProps> = ({
  activationScrollY = 160,
  scrollContainerId = "app-scroll-container",
  rightOffsetPx = 24,
  bottomOffsetPx = 24,
}) => {
  const { isScrollTopEnabled, scrollToTop } = useScrollTopAvailability({
    activationScrollY,
    scrollContainerId,
  });

  const handleScrollTop = useCallback(() => {
    scrollToTop();
  }, [scrollToTop]);

  if (!isScrollTopEnabled) return null;

  return (
    <Button
      type="button"
      onClick={handleScrollTop}
      variant="link"
      className="d-none bg-additional-violet d-md-flex position-fixed align-items-center justify-content-center rounded-circle p-0"
      style={{
        width: 60,
        height: 60,
        right: rightOffsetPx,
        bottom: bottomOffsetPx,
        zIndex: 1100,
      }}
    >
      <ArrowUp className="fs-18 text-primary" />
    </Button>
  );
};

export default ScrollTopButton;
